import React from "react";
import { useTranslation } from "../../i18n/useTranslation";

const Placeholder = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 text-center text-gray-500">
      {t("accountComingSoon")}
    </div>
  );
};

export default Placeholder;
